import React, { useState } from "react";
import { NavLink, Route, Routes, useNavigate } from "react-router-dom";
import { Logo } from "../assets/img";
import { useStateValue } from "../Context/StateProvider";
import { isActiveStyles, isNotActiveStyles } from "../utils/styles";
import { getAuth } from "firebase/auth";
import { app } from "../config/firebase.config";
import { motion } from "framer-motion";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import {
  FaComment,
  FaCrown,
  FaRegCommentDots,
  FaRegComments,
  FaUser,
} from "react-icons/fa";
import DashboardArtist from "./DashboardArtist";
import { FacebookMessengerIcon } from "react-share";
// import logo from "../assets/img/loglogo"

const Header = () => {
  const navigate = useNavigate();
  const [{ user }, dispatch] = useStateValue();

  const [isMenu, setIsMenu] = useState(false);

  const handleIseMenu = () => {
    setIsMenu(!isMenu);
  };
  const [isMessage, setIsMessage] = useState(false);

  const handleIseMessage = () => {
    setIsMessage(!isMessage);
  };
  const logout = () => {
    const firebaseAuth = getAuth(app);
    firebaseAuth
      .signOut()
      .then(() => {
        window.localStorage.setItem("auth", "false");
      })
      .catch((e) => console.log(e));
    navigate("/login", { replace: true });
  };

  const [nav, setNav] = useState(true);

  const handleNav = () => {
    setNav(!nav);
  };

  return (
    <header className="flex items-center w-full p-4 md:py-2 md:px-6">
      <NavLink to={"/"}>
        <img src={Logo} className="md:w-36 w-24" alt="" />
      </NavLink>
      <ul className="items-center justify-center hidden ml-7 md:flex ">
        {/* prettier-ignore */}
        <li className="mx-5 text-lg"><NavLink to={'/Home'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Home</NavLink></li>
        {/* prettier-ignore */}
        <li className="mx-5 text-lg"><NavLink to={'/Musics'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Musics</NavLink></li>
        {/* prettier-ignore */}
        <li className="mx-5 text-lg"><NavLink to={'/Cm'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Choir Masters</NavLink></li>
        {/* prettier-ignore */}
        {/* <li className="mx-5 text-lg"><NavLink to={'/Contact'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles}>Contact</NavLink></li> */}
      </ul>
      {/*  */}
      <div
        onClick={handleNav}
        className="block absolute left-[4%] top-[18.5%] md:hidden"
      >
        {!nav ? (
          <AiOutlineClose size={25} className="pointer-corsor text-red-500" />
        ) : (
          <AiOutlineMenu size={25} className="pointer-corsor text-red-600" />
        )}
      </div>
      <ul
        className={
          !nav
            ? "fixed left-0 top-[20%] w-[70%] h-[30%] z-50 rounded-lg border-r-gray-900 bg-gray-500 ml-2 opacity-90 ease-in-out duration-500 drop-shadow-4xl font-extrabold"
            : "fixed left-[-100%]"
        }
      >
        {/* prettier-ignore */}
        <li className="mx-5 text-4xl font-serif border-b"><NavLink to={'/Home'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles} style={{color: "white"}}>Home</NavLink></li>
        {/* prettier-ignore */}
        <li className="mx-5 text-4xl font-serif border-b"><NavLink to={'/Musics'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles} style={{color: "white"} }>Musics</NavLink></li>
        {/* prettier-ignore */}
        <li className="mx-5 text-4xl font-serif border-b"><NavLink to={'/Cm'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles} style={{color: "white"}}>C/M</NavLink></li>
        {/* prettier-ignore */}
        {/* <li className="mx-5 text-4xl font-serif"><NavLink to={'/Contact'} className={({isActive}) => isActive ? isActiveStyles : isNotActiveStyles} style={{color: "white"}}>Contact</NavLink></li> */}
      </ul>
      {/*  */}
      <div
        className="flex items-center ml-auto cursor-pointer gap-2 relative"
        onClick={() => setIsMenu(handleIseMenu)}
        // onClick={() => setIsMenu(false)}
      >
        <img
          className="w-12 min-w-[44px] object-cover rounded-full shadow-lg z-50"
          src={user?.user?.imageURL}
          alt=""
          referrerpolicy="no-referrer"
        />
        <FaUser className="absolute left-[26%] md:left-[24%] text-white text-3xl md:text-4xl bg-red-600 rounded-full p-0.5" />
        {isMenu && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            className="absolute z-10 top-3 right-0 w-275 p-4 gap-4 bg-card shadow-lg rounded-lg backdrop-blur-sm flex flex-col"
          >
            <div className="flex flex-col">
              <p className="text-textColor text-lg hover:text-headingColor font-semibold">
                {user?.user.name}
              </p>
              <p className="flex items-center gap-2 text-xs text-gray-500 font-normal">
                Premium Member.{" "}
                <FaCrown className="text-xm -ml-1 text-yellow-500" />{" "}
              </p>
            </div>
            <NavLink to={"/userProfile"}>
              <p className="text-base text-textColor hover:font-semibold duration-150 transition-all ease-in-out">
                Profile
              </p>
            </NavLink>
            <p className="text-base text-textColor hover:font-semibold duration-150 transition-all ease-in-out">
              My Favourites
            </p>
            <hr />
            {user?.user.role === "admin" && (
              <>
                <NavLink to={"/dashboard/home"}>
                  <p className="text-base text-textColor hover:font-semibold duration-150 transition-all ease-in-out">
                    Dashboard
                  </p>
                </NavLink>
                <hr />
              </>
            )}
            <p
              className="text-base text-textColor hover:font-semibold duration-150 transition-all ease-in-out"
              onClick={logout}
            >
              Sign out
            </p>
          </motion.div>
        )}
      </div>{" "}
      {/* <div className="my-4 w-full p-4 absolute hover:bg-black z-50 top-[20%]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/DashboardArtist" element={<DashboardArtist />} />
        </Routes>
      </div> */}
      <FaRegComments
        className="fixed text-[#00cc00] text-4xl top-[90%] z-50"
        onClick={() => setIsMessage(handleIseMessage)}
      />
      {isMessage && (
        <div className=" bg-slate-300 p-1 fixed text-center top-[62%] rounded-lg z-10">
          {" "}
          <form action="https://formspree.io/f/mwkjprql" method="POST">
            <input
              type="text"
              name="name"
              className="user"
              placeholder="Name"
              style={{
                marginBottom: 10,
                marginTop: 5,
                borderRadius: 3,
                padding: 1,
              }}
            />{" "}
            <br />
            <input
              type="email"
              name="email"
              className="user"
              placeholder="Email"
              style={{
                marginBottom: 10,
                marginTop: 5,
                borderRadius: 3,
                padding: 1,
              }}
            />{" "}
            <br />
            <textarea
              name="message"
              className="user"
              placeholder="Message"
              style={{
                marginBottom: 10,
                marginTop: 5,
                borderRadius: 3,
                padding: 1,
              }}
            />{" "}
            <br />
            <input
              type="submit"
              value="Send"
              className="button"
              style={{
                backgroundColor: "#00cc00",
                padding: 2,
                width: 80,
                borderRadius: 3,
              }}
            />{" "}
            <br />
            <span>{"Thanks for Contacting me"}</span>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;
